<health-data-page
    [chartLabel]="chartLabel"
    [healthDataLabel]="healthDataLabel"
    [healthDataType]="respiratoryRateHealthDataType"
    [hasTwoDecimals]="hasTwoDecimals"
    [payloadTypes]="payloadTypes"
/>
